(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5656],{

/***/ 73547:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/listings/[uuid]",
      function () {
        return __webpack_require__(62367);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 59185:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "B": function() { return /* binding */ ListingNotFound; }
});

// UNUSED EXPORTS: getDefaultCityOfCurrentLocale

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(93288);
// EXTERNAL MODULE: ./node_modules/@casavo/base-ui/dist/index.es.js
var index_es = __webpack_require__(79713);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(32852);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(88082);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(89847);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(32466);
// EXTERNAL MODULE: ./src/components/Header/index.tsx + 14 modules
var Header = __webpack_require__(19588);
// EXTERNAL MODULE: ./src/components/Link/linkBuilder.ts
var linkBuilder = __webpack_require__(13976);
// EXTERNAL MODULE: ./src/design-lib/components/ButtonLink/index.tsx
var ButtonLink = __webpack_require__(36898);
// EXTERNAL MODULE: ./src/design-lib/style-theme/sprinkles.css.ts
var sprinkles_css = __webpack_require__(20579);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(44926);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./src/heads/listing-not-found.tsx



var ListingNotFoundHead = function() {
    var ref = (0,useTranslation/* default */.Z)(), lang = ref.lang, t = ref.t;
    var metaTitle = t("listing-detail:title_not_found") + " | Casavo";
    var metaDescription = t("common:listing_not_found_title");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: metaTitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                content: metaDescription,
                name: "description"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                content: metaTitle,
                property: "og:title"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                content: metaDescription,
                property: "og:description"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                content: lang,
                property: "og:locale"
            })
        ]
    });
};
/* harmony default export */ var listing_not_found = (ListingNotFoundHead);

// EXTERNAL MODULE: ./src/shared-styles/styles.css.ts
var styles_css = __webpack_require__(29070);
// EXTERNAL MODULE: ./src/utils/locale-variables/index.ts
var locale_variables = __webpack_require__(98640);
// EXTERNAL MODULE: ./src/utils/locale-variables/menuLinks.ts
var menuLinks = __webpack_require__(87264);
// EXTERNAL MODULE: src/design-lib/style-theme/theme.css.ts.vanilla.css!=!./node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{"fileName":"src/design-lib/style-theme/theme.css.ts.vanilla.css","source":"#H4sIAAAAAAAAA42UyW6cQBCG73mKkrgkkomo3rtyAhpeI5rxvg4ez9jYUd49KkY5dLWRLDh91PL331XQfrc7wJ9vAHX9Gx+PN+HpviGoxnG0Q/yVcVx4cq3NuVp4F5zKuV54jDjm3BBUgwst9jm3Cx/6ocu5I6hi12HX5NwTVBa99ybngaBqnE5a6I/MrUY15HzDfeMYR5fzLUHVhsGlNufnBJVzyXTiXBcElbI9tjrnlwQVDrENwp8rgiq50Y6izjX75kY3Ys5vTvcyyvhb5pafnN/xuQI/Ob/nviaZJHQ+EFSd7nQndD4SVF577QV/Yv+VVVbo3PF5EyYU9zgxVxhQ+P/M+psxDoLv2X+TYhT+vxBUwfbJi/s98L34vrE+50fWmdpkRP3XRX9sjbj3t5PPcRDzOZ/mPwZR533hfXJCz8eJN0b4jM0y6G3SogHyhvV9bLVQhMuKpWGQFuGyYzq20iNclmz0UZqEy5Z11kuX0C1jYQZpE/Kedb1x0icMKwOJce0Psln5JeB2LeN8ZZjwYmVL8HIt42pljvF67cPNyoTj7VqPu5VZxvuVIcQHggbcNIMy0wwN7K+3m+8qnvHrz5qf+odIeOQENc0Qvhb/xPFcG93XEnacgNMMXxQ0ETTTLOAzQW1CgfcEtTMFfiGoQ1nkQFBHV+AjQa3KIq8ENZbRbxxd1p65ZUHfuYYq8AdBrQusGj5kQZEbFlQRlH4oTVDaoQxB6YayBKUZyhFsjoedoJ6gdEgFgtIgFQlKf9SGoJS7JSjdUecEn5hzQVAquCQoI6/+y/r7Dy2XybuPCAAA"}!./node_modules/@vanilla-extract/webpack-plugin/extracted/dist/vanilla-extract-webpack-plugin-extracted.cjs.js
var vanilla_extract_webpack_plugin_extracted_cjs = __webpack_require__(19636);
// EXTERNAL MODULE: src/containers/ListingNotFound/styles.css.ts.vanilla.css!=!./node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{"fileName":"src/containers/ListingNotFound/styles.css.ts.vanilla.css","source":"Ll8xN2JucGtvMSB7CiAgbWFyZ2luLXRvcDogdmFyKC0tXzFtdWg4bmsxcSk7CiAgbWFyZ2luLWJvdHRvbTogdmFyKC0tXzFtdWg4bmsyMik7CiAgbWF4LXdpZHRoOiAxMjAwcHg7Cn0KQG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogMTAyNHB4KSB7CiAgLl8xN2JucGtvMCB7CiAgICBtYXgtd2lkdGg6IDY0MHB4OwogIH0KfQ=="}!./node_modules/@vanilla-extract/webpack-plugin/extracted/dist/vanilla-extract-webpack-plugin-extracted.cjs.js
var dist_vanilla_extract_webpack_plugin_extracted_cjs = __webpack_require__(15250);
;// CONCATENATED MODULE: ./src/containers/ListingNotFound/styles.css.ts


var imgContainer = '_17bnpko0';
var suggestedLinkContainer = '_17bnpko1';
;// CONCATENATED MODULE: ./src/containers/ListingNotFound/index.tsx















/** Redirects to the default city of the locale if the user lands on the page of a city that does not
 *  match to the current locale (to prevent nasty error pages) */ var getDefaultCityOfCurrentLocale = function(locale) {
    // const countryOfCurentCity = currentCity.country || lang
    var localesOfCurrentCity = localesByCountryName[locale] || [];
    if (!localesOfCurrentCity.includes(locale)) {
        return defaultCitiesByLocale[locale];
    }
    // return currentCity.slug
    return locale;
};
var ListingNotFound = function() {
    var ref = (0,useTranslation/* default */.Z)(), lang = ref.lang, t = ref.t;
    var headerData = (0,menuLinks/* getMenuLinks */.h)(lang);
    var ref1 = config_default()(), _publicRuntimeConfig = ref1.publicRuntimeConfig, imageBasePath = _publicRuntimeConfig.imageBasePath, lisaWebsite = _publicRuntimeConfig.lisaWebsite;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(listing_not_found, {}),
            typeof headerData !== "undefined" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* Header */.h, {
                links: headerData
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()(styles_css/* backgroundColor.lightBlue */.Cz.lightBlue, (0,sprinkles_css/* sprinkles */.K)({
                    textAlign: "center"
                })),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classnames_default()(imgContainer, (0,sprinkles_css/* sprinkles */.K)({
                            margin: "auto",
                            paddingBottom: "5xl",
                            paddingTop: {
                                mobile: "xl"
                            },
                            paddingX: "m"
                        })),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                alt: "",
                                className: (0,sprinkles_css/* sprinkles */.K)({
                                    marginBottom: "m",
                                    marginX: "auto"
                                }),
                                height: "300",
                                loading: "lazy",
                                src: "".concat(imageBasePath, "/images/concepts/home-chapter-woman.svg"),
                                width: "300"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (0,sprinkles_css/* sprinkles */.K)({
                                    textAlign: "center"
                                }),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Heading2 */.XJ, {
                                        className: styles_css/* marginBottom.2xl */.yl["2xl"],
                                        children: t("common:listing_not_found_title")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* BodyLarge */.f2, {
                                        className: (0,sprinkles_css/* sprinkles */.K)({
                                            paddingX: {
                                                mobile: "xl"
                                            }
                                        }),
                                        children: t("common:listing_not_found_similar_properties_subtitle")
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,sprinkles_css/* sprinkles */.K)({
                            paddingBottom: "4xl",
                            textAlign: "center"
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLink/* ButtonLink */.Z, {
                            isNextLink: true,
                            href: lisaWebsite + linkBuilder/* linkBuilder.housesForSale.url */.H.housesForSale.url(lang),
                            label: t("common:listing_not_found_cta"),
                            styleVariant: "secondary"
                        })
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 36898:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ButtonLink; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(29559);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3292);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var _casavo_base_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79713);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32852);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66731);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32466);
/* harmony import */ var _components_ConditionalWrapper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(28820);
/* harmony import */ var _design_lib_style_theme_sprinkles_css__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(20579);
/* eslint-disable react/display-name */ 








var ButtonLink = function(_param) {
    var Icon = _param.Icon, ariaLabel = _param.ariaLabel, center = _param.center, className = _param.className, colorVariant = _param.colorVariant, fullWidth = _param.fullWidth, href = _param.href, _isNextLink = _param.isNextLink, isNextLink = _isNextLink === void 0 ? true : _isNextLink, label = _param.label, onClick = _param.onClick, rel = _param.rel, sizeVariant = _param.sizeVariant, styleVariant = _param.styleVariant, target = _param.target, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_param, [
        "Icon",
        "ariaLabel",
        "center",
        "className",
        "colorVariant",
        "fullWidth",
        "href",
        "isNextLink",
        "label",
        "onClick",
        "rel",
        "sizeVariant",
        "styleVariant",
        "target"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ConditionalWrapper__WEBPACK_IMPORTED_MODULE_5__/* .ConditionalWrapper */ .M, {
        condition: isNextLink,
        wrapper: function(children) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                passHref: true,
                href: href,
                children: children
            });
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((0,_design_lib_style_theme_sprinkles_css__WEBPACK_IMPORTED_MODULE_6__/* .sprinkles */ .K)({
                cursor: "pointer",
                display: "inline-block"
            }), className),
            href: !isNextLink && href,
            rel: rel,
            target: target,
            onClick: onClick,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_casavo_base_ui__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
                asLink: true,
                ariaLabel: ariaLabel,
                center: center,
                colorVariant: colorVariant,
                fullWidth: fullWidth,
                Icon: Icon,
                label: label,
                sizeVariant: sizeVariant,
                styleVariant: styleVariant
            }, props))
        })
    });
};


/***/ }),

/***/ 62367:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var _containers_ListingNotFound__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59185);
// @ts-ignore


var ListingUuidPage = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_containers_ListingNotFound__WEBPACK_IMPORTED_MODULE_1__/* .ListingNotFound */ .B, {});
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (ListingUuidPage);
 // @ts-ignore


/***/ }),

/***/ 15250:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5949,8009,7385,8396,7769,2715,2153,5829,9774,2888,179], function() { return __webpack_exec__(73547); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);